import { fetcher } from '@commenda/utils';
import {
  ApproveBulkRecordFilterResponse,
  BulkActionResponse,
  RejectBulkRecordFilterResponse,
  SourceRecordActionRequestPayload,
  SourceRecordBulkActionRequestPayload,
} from './types';

export async function bulkApproveSourceRecords(
  data: SourceRecordBulkActionRequestPayload
): Promise<{
  success: boolean;
  data: ApproveBulkRecordFilterResponse | undefined;
  error: Error | undefined;
}> {
  try {
    const response = await fetcher('new-sales-tax/source-record/bulk-approve', {
      method: 'POST',
      body: data,
    });

    const responseData = await response.json();

    if (!response.ok) {
      return {
        success: false,
        data: undefined,
        error: new Error(
          responseData.message || 'Failed to bulk approve records.'
        ),
      };
    }

    return {
      success: true,
      data: responseData.data,
      error: undefined,
    };
  } catch (error) {
    return {
      success: false,
      data: undefined,
      error: new Error(
        error instanceof Error ? error.message : 'An unexpected error occurred'
      ),
    };
  }
}

export async function bulkRejectSourceRecords(
  data: SourceRecordBulkActionRequestPayload
): Promise<{
  success: boolean;
  data: RejectBulkRecordFilterResponse | undefined;
  error: Error | undefined;
}> {
  try {
    const response = await fetcher('new-sales-tax/source-record/bulk-reject', {
      method: 'POST',
      body: data,
    });

    const responseData = await response.json();

    if (!response.ok) {
      return {
        success: false,
        data: undefined,
        error: new Error(
          responseData.message || 'Failed to bulk reject records.'
        ),
      };
    }

    return {
      success: true,
      data: responseData.data,
      error: undefined,
    };
  } catch (error) {
    return {
      success: false,
      data: undefined,
      error: new Error(
        error instanceof Error ? error.message : 'An unexpected error occurred'
      ),
    };
  }
}

export async function approveSourceRecord(
  id: string,
  data: SourceRecordActionRequestPayload
): Promise<{
  success: boolean;
  data: BulkActionResponse | undefined;
  error: Error | undefined;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/source-record/${id}/approve`,
      {
        method: 'POST',
        body: {
          ...data,
        },
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      return {
        success: false,
        data: undefined,
        error: new Error(responseData.message || 'Failed to approve address'),
      };
    }

    return {
      success: true,
      data: responseData.data,
      error: undefined,
    };
  } catch (error) {
    return {
      success: false,
      data: undefined,
      error: new Error(
        error instanceof Error ? error.message : 'An unexpected error occurred'
      ),
    };
  }
}

export async function rejectSourceRecord(
  id: string,
  data: SourceRecordActionRequestPayload
): Promise<{
  success: boolean;
  data: BulkActionResponse | undefined;
  error: Error | undefined;
}> {
  try {
    const response = await fetcher(`new-sales-tax/source-record/${id}/reject`, {
      method: 'POST',
      body: {
        ...data,
      },
    });

    const responseData = await response.json();

    if (!response.ok) {
      return {
        success: false,
        data: undefined,
        error: new Error(responseData.message || 'Failed to reject address'),
      };
    }

    return {
      success: true,
      data: responseData.data,
      error: undefined,
    };
  } catch (error) {
    return {
      success: false,
      data: undefined,
      error: new Error(
        error instanceof Error ? error.message : 'An unexpected error occurred'
      ),
    };
  }
}
